import React, { useEffect, useRef, useState } from 'react';
import Scheduler from 'devextreme-react/scheduler';
import Box, { Item } from "devextreme-react/box";
import moment from 'moment';
import Title from "../../components/shared/Title";
import http from '../../utils/http';
import uri from '../../utils/uri';
import CustomStore from 'devextreme/data/custom_store';
import { dialogAppointmentAction } from '../../store/appointment/appointmentDialogReducer';
import { datetime } from '../../utils/common';
import BlockHeader from '../../components/shared/BlockHeader';
import ContextMenu from 'devextreme-react/context-menu';
import List from '../activities/List';
import useAuthorization from '../../hooks/useAuthorization';
import { resources, dataAccess } from '../../data/app';
import { useDispatch, useSelector } from 'react-redux';

import './index.css';
import notify from 'devextreme/ui/notify';
import Nuevo from './Nuevo';
import Graduaciones from '../../components/graduaciones/Graduaciones';
const Appointment = props => {

    const { history } = props;

    const refAgenda = useRef();

    const { authorized } = useAuthorization([resources.agenda, dataAccess.access]);

    const [catalogs, setCatalogs] = useState({
        actividades: [],
        clientes: [],
        doctores: [],
        categories: [],
    });

    const title = "Agenda";
    const views = ['day', 'week', 'month', 'timelineDay', 'agenda'];

    const currentDate = new Date();

    const customStore = new CustomStore({
        load: (loadOptions) => {

            const { desde, hasta } = loadOptions;
         
            let params = {};

            if (desde != undefined) {

                params.desde = moment(desde).format();
                params.hasta = moment(hasta).format();

            } else {

                params.desde = moment(loadOptions.filter[0][0][0][2]).format();
                params.hasta = moment(loadOptions.filter[0][0][1][2]).format();

            }

            return http(`${uri.appointments.get}`)
                .asPost(params)
                .then((data) => {
                    return data.map(x => {

                        x.startDate = x.dateTime;
                        x.text = x.name;

                        return x;

                    })
                })
                .catch(() => { throw 'Data Loading Error'; });
        },
        insert: (data) => {
            return new Promise(resolve =>
                http(uri.appointments.insert).asPost({ ...data, dateTime: moment(data.startDate).format('YYYY-MM-DD HH:mm') }).then(result => {
                    resolve(result);
                })
            )
        },
        update: (data, dataModificada) => {

            dataModificada.dateTime = moment(dataModificada.startDate).format('YYYY-MM-DD HH:mm')

            return new Promise(resolve =>
                http(uri.appointments.insert).asPost({ ...data, ...dataModificada }).then(result => {
                    resolve(result);
                })

            )
        },
        remove: catalogo => {
            return new Promise(resolve =>
                http(uri.appointments.remove(catalogo.id)).asGet().then(result => {
                    resolve(result);
                })
            )
        }

    });

    const getCurrentDate = () => {

        const { defaultCurrentDate } = refAgenda.current.props;
        const date = moment(defaultCurrentDate);
        const desde = date.format();
        const hasta = date.add(1, 'days').format();

        return  { desde, hasta }

    }

    const awaiting = id => {

        http(`appointments/${id}/Awaiting`).asGet().then(resp => {
            // notify("Cliente en espera");
            // const { desde, hasta } = getCurrentDate();
            // customStore.load({ desde, hasta });
            setCatalogs({...catalogs, loading : false});
        });

    }

    const attended = id => {

        http(`appointments/${id}/attended`).asGet().then(resp => {
            // notify("Cliente atendido");
            // const { desde, hasta } = getCurrentDate();
            // customStore.load({ desde, hasta });
            setCatalogs({...catalogs, loading : false});

        });

    }

    useEffect(() => {

        Promise.all(
            [
                http(uri.activities.get).asGet(),
                http(uri.doctors.get).asGet(),
                http(`catalogos/Category`).asGet(),
            ]
        ).then(result => {

            setCatalogs({
                actividades: result[0],
                doctores: result[1],
                categories: result[2],
            });

        });

    }, [0]);

    const onAppointmentFormOpening = data => {

        const startDate = new Date(data.appointmentData.startDate);
        if (isWeekend(startDate)) {
            data.cancel = true;
            notify('No se puede crear una cita en esta fecha', 'warning', 1000);
        } else
            openThisDialog(data.appointmentData.id || 0, startDate);

    }

    const getIcon = data => {

        const position = {position: 'absolute'}

        if(data.awaiting)
            return <span className="fa fa-clock" style={{...position}}></span>
        if(data.attended)
            return <span className="fa fa-check" style={{...position}}></span>
        if(data.noAttended)
            return <span className="dx-icon-close" style={{...position}}></span>

        return <span className="dx-icon-help" style={{...position}}></span>
    }

    const appointmentComponent = (model) => {

        if (catalogs.doctores.length > 0) {

            const { appointmentData } = model.data;
            let doctor = catalogs.doctores.find(x => x.id == appointmentData.doctorId);
            let category = catalogs.categories.find(x => x.id == appointmentData.categoryId);

            return (
                <div className="showtime-preview">
                    <div>
                        {getIcon(appointmentData)}                        
                    </div>
                    <div className="agenda-row">
                        <div style={{ color: appointmentData.fontColor, marginLeft : '30px' }}><b>{appointmentData.fileNumber}</b> {appointmentData.name}</div>
                        <div style={{ color: appointmentData.fontColor}} className="showtime-doctor">{category.name}</div>
                    </div>
                    <div className="agenda-row">
                        <div className="showtime-doctor" style={{ color: appointmentData.fontColor, marginLeft : '30px'  }}>
                            Doc: <strong>{doctor.fullName}</strong>
                        </div>
                        <div style={{ color: appointmentData.fontColor }}>
                            {moment(appointmentData.startDate).format('HH:mm a')}
                            {' - '}
                            {moment(appointmentData.endDate).format('HH:mm a')}
                        </div>
                    </div>
                </div>
            );
        }
    }

    const { appInfo } = useSelector(store => store);

    const renderAppointmentTooltip = (model) => {

        const { color, fontColor, name, startDate, endDate, doctor, activity } = model.appointmentData;

        return (
            <div className='tool-actividad-schedule'>
                <p>Paciente: {name}</p>
                <p>Actividad: <span className='actividad-schedule' style={{ color : fontColor, backgroundColor: color }}>{activity}</span> </p>
                <p>Doctor: {doctor}</p>
                <p>Hora: {moment(startDate).format('hh:mm a')} - {moment(endDate).format('hh:mm a')}</p>
            </div>
        );
    }

    const isWeekend = date => {
        const day = date.getDay();
        return day === 0 || day === 6;
    }

    const DateCell = _props => {
        const { date, text } = _props;

        return (
            <div className={isWeekend(date) ? 'disable-date' : null}>
                <div>{text}</div>
            </div>
        );
    }

    const [contextMenu, setContextMenu] = useState({
        contextMenuItems: [],
        target: null,
        disabled: true,
        contextMenuEvent: null
    });

    const openWindows = url => {

        var params = [
            'height='+ window.screen.height,
            'width='+ window.screen.width,
            'fullscreen=yes' // 
        ].join(',');

        window.open(url,  'popup_window', params)
    }

    const appointmentContextMenuItems = [
        {
            text: 'Nuevo',
            onItemClick: e => {
                openThisDialog(0, e.targetedAppointmentData.dateTime)
            }
        },{
            text: 'Abrir',
            onItemClick: e => {
                const { id } = e.appointmentData;
                openThisDialog(id)
            }
        // }, {
        //     text: 'Eliminar',
        //     onItemClick: e => {
        //         customStore.remove(e.appointmentData).then(() => refAgenda.current.instance.refresh());
        //     }
        }, {
            text: 'Registrar graduaciones',
            beginGroup: true,
            onItemClick: e => {

                openWindows('/clinica/cliente/'+e.appointmentData.clientId +'?q=0');
              
            }
        },
        {
            text: 'Registrar contactologia',
            onItemClick: e => {
                
                openWindows('/clinica/cliente/'+e.appointmentData.clientId +'?q=1');

            }
        },

        {
            text: 'Paciente en espera',
            beginGroup: true,
            onItemClick: e => {

                const { id } = e.appointmentData;
                awaiting(id);

            }
        },
        {
            text: 'Paciente atendido',
            onItemClick: e => {
                const { id } = e.appointmentData;
                attended(id);
            }
        },
        { text: 'Enviar aviso sms', beginGroup: true, }
    ];

    const cellContextMenuItems = [
        {
            text: 'Nuevo', onItemClick: e => {
                openThisDialog(0, e.cellData.startDate)
            }
        }
    ];

    const onAppointmentContextMenu = e => {
        setContextMenu({
            ...contextMenu,
            target: '.dx-scheduler-appointment',
            disabled: false,
            contextMenuItems: appointmentContextMenuItems,
            contextMenuEvent: e
        })
    }

    const onCellContextMenu = e => {
        setContextMenu({
            ...contextMenu,
            target: '.dx-scheduler-date-table-cell',
            disabled: false,
            contextMenuItems: cellContextMenuItems,
            contextMenuEvent: e
        })
    }

    const onContextMenuItemClick = e => {
        const { contextMenuEvent } = contextMenu;
        e.itemData.onItemClick(contextMenuEvent, e);
    }
    const dispatch = useDispatch();
    const openThisDialog = (id, startDate) => dispatch(dialogAppointmentAction({ open: true, id, startDate }));

    return authorized(
        <div className="container">
            <Title title={title} />
            <BlockHeader title={title} />
            <Nuevo catalogs={catalogs} />           
            <Box direction="row" width="100%" height={75}>
                <Item ratio={5}>
                    <Scheduler
                        ref={refAgenda}
                        dataSource={customStore}
                        views={views}
                        defaultCurrentView="day"
                        defaultCurrentDate={currentDate}
                        firstDayOfWeek={0}
                        startDayHour={8}
                        endDayHour={17}
                        height={600}
                        showAllDayPanel={false}
                        crossScrollingEnabled={true}
                        cellDuration={appInfo.intervalAppoinment}
                        remoteFiltering={true}
                        dateCellRender={DateCell}
                        appointmentComponent={appointmentComponent}
                        onAppointmentFormOpening={onAppointmentFormOpening}
                        appointmentTooltipRender={renderAppointmentTooltip}
                        onAppointmentRendered={e => {     

                            if(e.appointmentData.attended)
                                e.appointmentElement.style.backgroundColor = '#b0b0b0'
                            else
                                e.appointmentElement.style.backgroundColor = e.appointmentData.color

                        } }
                        onAppointmentContextMenu={onAppointmentContextMenu}
                        onCellContextMenu={onCellContextMenu}
                    >
                    </Scheduler>
                    <ContextMenu
                        dataSource={contextMenu.contextMenuItems}
                        width={200}
                        target={contextMenu.target}
                        disabled={contextMenu.disabled}
                        onItemClick={onContextMenuItemClick}
                    // itemRender={AppointmentMenuTemplate}
                    // onHiding={this.onContextMenuHiding}
                    />
                </Item>
                <Item ratio={1}>
                    <div className="ml-10">
                        <List />
                    </div>
                </Item>
            </Box>
        </div>
    );
}

export default Appointment;
